import { IServerActions } from "../types/serverActions";

export const secureRoutePath = (routePath: IServerActions["routePath"]) => {
  // Replace all '/' except for the one at the beginning with '-'
  const modifiedString = routePath.replace(/(?!^)\//g, '-');
  
  // Ensure the string starts with '/'
  return modifiedString.startsWith('/') ? modifiedString : '/' + modifiedString;
}